import { render, staticRenderFns } from "./CompanyListItem.vue?vue&type=template&id=072fe5a8&scoped=true&lang=pug"
import script from "./CompanyListItem.vue?vue&type=script&lang=ts"
export * from "./CompanyListItem.vue?vue&type=script&lang=ts"
import style0 from "./CompanyListItem.vue?vue&type=style&index=0&id=072fe5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072fe5a8",
  null
  
)

export default component.exports